import { useState } from 'react';
import { useQuery } from '@apollo/client/react';

import { GET_USER_GROUP } from '@atom/graph/userGroup';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Progress } from '@atom/mui';

import UserGroupHeader from './header/UserGroupHeader';
import UserGroupBudgets from './userGroupBudgets/UserGroupBudgets';
import UserGroupCerts from './userGroupCertifications/UserGroupCerts';
import UserGroupInfo from './userGroupInfo/UserGroupInfo';
import UserGroupRoles from './userGroupRoles/UserGroupRoles';
import UserGroupContext, { View } from './UserGroupContext';

import classes from './userGroupDetail.module.css';

const UserGroupDetail = () => {
  const [activeView, setActiveView] = useState<View>(View.INFO);
  const [, { params }] = useNavigation();
  const { id } = params;

  const { loading, data, error, refetch } = useQuery(GET_USER_GROUP, {
    variables: {
      id,
    },
    fetchPolicy: 'network-only',
  });

  if (error || !data) {
    return <Progress style={{ height: '100%' }} />;
  }

  const getActiveView = () => {
    const views = {
      [View.INFO]: <UserGroupInfo />,
      [View.BUDGETS]: <UserGroupBudgets />,
      [View.CERTIFICATIONS]: <UserGroupCerts />,
      [View.ROLES]: <UserGroupRoles />,
    };

    return views[activeView];
  };

  const contextValue = {
    activeView,
    setActiveView,
    userGroup: data.userGroup,
    loading,
    refetch,
  };

  return (
    <UserGroupContext.Provider value={contextValue}>
      <div className={classes.teamDetailContainer}>
        <UserGroupHeader />
        <div className={classes.contentContainer}>
          <div className={classes.centerPaneContainer}>
            <div className={classes.centerPane}>{getActiveView()}</div>
          </div>
        </div>
      </div>
    </UserGroupContext.Provider>
  );
};

export default UserGroupDetail;
